export const handleGetCheckModulePermission = async (
  usermoduleswithpermissions,
  moduleName
) => {
  let permission = usermoduleswithpermissions?.filter((md) => {
    return moduleName === md.moduleName;
  });
  return permission[0]?.permissionType === "read" ? false : true
};
